<template>
    <section class="posts">
        <FeedSkeleton
            v-if="loading"/>
        <PostFeed v-else
            :posts="userPosts"/>
        <FeedSkeleton class="resetMargin"
            v-if="!reachedBottom && userPosts.length !== 0" v-view="handleView"/>
    </section>
</template>

<script>
    import { mapActions, mapState } from 'vuex'

    import PostFeed from '@/components/blog/main/PostFeed'
    import FeedSkeleton from '@/components/layout/main/FeedSkeleton'

    export default {
        name: 'Creator',
        components: {
            PostFeed,
            FeedSkeleton
        },
        props: {
            id: String,
            slug: String
        },
        data() {
            return {
                loading: true
            }
        },
        computed: {
            ...mapState('users',['lastVisitedSlug']),
            ...mapState('blog', ['userPosts','reachedBottom']),

            lastVisible() {
                return this.userPosts[this.userPosts.length - 1]
            }
        },
        methods: {
            ...mapActions('users',['setLastVisitedSlug']),
            ...mapActions('blog', ['fetchPosts', 'fetchPostsAfter', 'setReachedBottomToDefault','purgeUserPosts']),

            async handleView(event) {
                if(event.type === 'enter' && !this.loading) {
                    await this.fetchPostsAfter({
                        authorID: this.id,
                        visibility: true,
                        commitName: 'addUserPosts',
                        lastVisible: this.lastVisible,
                        limit: 2
                    })
                }
            },
            async loadFeed() {
                try {
                    this.setReachedBottomToDefault()
                    await this.fetchPosts({
                        authorID: this.id,
                        visibility: true,
                        commitName: 'setUserPosts',
                        limit: 2
                    })
                    this.loading = false
                } catch (e) {
                    throw e
                }
            }
        },
        async mounted() {
            if(this.userPosts.length === 0) {
                this.loadFeed()
            } else if(this.slug !== this.lastVisitedSlug) {
                this.purgeUserPosts()
                this.loadFeed()
                setTimeout(() => {
                    window.scrollTo(0, 0)
                })
            } else {
                this.loading = false
            }
            this.setLastVisitedSlug(this.slug)
        }
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .posts {
        flex: 1;
    }
</style>
